import type { ProductType, ProductPricePurchaseType } from '@/types/api/product';
import { displayPurchaseTypeFromUnit } from '@/lib/productSalesUnitTableDisplay';

/**
 * 프로덕트 관리 화면의 "콘텐츠" 타입 필터와 동일.
 * 클래스 생성/수정 시 프로덕트 선택 목록도 이 집합을 사용해야 건수가 일치합니다.
 */
export const CONTENT_LIKE_PRODUCT_TYPES: readonly ProductType[] = [
	'CONTENT',
	'OPEN_CLASS',
	'ORGANIZATION_CLASS',
] as const;

export function isContentLikeProductType(type: ProductType): boolean {
	return (CONTENT_LIKE_PRODUCT_TYPES as readonly string[]).includes(type);
}

/**
 * 기관클래스 생성·수정 폼의 프로덕트 셀렉트 — 오픈클래스용(OPEN_CLASS)·장비·커스텀 제외.
 * CONTENT·ORGANIZATION_CLASS 만(프로덕트 등록·수정에서 다루는 콘텐츠형).
 */
export const INSTITUTION_CLASS_SELECTABLE_PRODUCT_TYPES: readonly ProductType[] = [
	'CONTENT',
	'ORGANIZATION_CLASS',
] as const;

export function isInstitutionClassProductSelectType(type: ProductType): boolean {
	return (INSTITUTION_CLASS_SELECTABLE_PRODUCT_TYPES as readonly string[]).includes(type);
}

/**
 * POST/PUT 요청 본문의 `type` — OpenAPI·백엔드는 CONTENT | EQUIPMENT | CUSTOM_SERVICE 만 받음.
 * UI·목록용 OPEN_CLASS / ORGANIZATION_CLASS 는 콘텐츠로 취급해 CONTENT 로 보냄(미매핑 시 서버 500 가능).
 */
export function toWritableApiProductType(
	type: ProductType
): 'CONTENT' | 'EQUIPMENT' | 'CUSTOM_SERVICE' {
	if (type === 'EQUIPMENT') return 'EQUIPMENT';
	if (type === 'CUSTOM_SERVICE') return 'CUSTOM_SERVICE';
	return 'CONTENT';
}

/**
 * POST /product·createPriceList 등 — `docs/api/product.md` PurchaseType.
 * `ProductType`이 CONTENT가 아니면 `NONE`, CONTENT면 UI 판매단위 unit → API enum.
 */
export function resolveApiPurchaseTypeForProductPrice(
	productType: ProductType,
	priceUnit?: string
): ProductPricePurchaseType {
	if (toWritableApiProductType(productType) !== 'CONTENT') {
		return 'NONE';
	}
	return displayPurchaseTypeFromUnit(priceUnit);
}
